import { inject, injectable, Store } from '@servicetitan/react-ioc';

import { makeObservable, observable, runInAction } from 'mobx';

import { CampaignConfigurationsApi } from './campaign-configurations.api';

export interface ICampaignConfigurationsStore {
    isCategoryRequired: boolean;
}

@injectable()
export class CampaignConfigurationsStore extends Store implements ICampaignConfigurationsStore {
    @observable isCategoryRequired!: boolean;

    constructor(
        @inject(CampaignConfigurationsApi) private readonly api: CampaignConfigurationsApi
    ) {
        super();
        makeObservable(this);
    }

    async initialize() {
        const { isCategoryRequired } = (await this.api.get()).data;

        runInAction(() => {
            this.isCategoryRequired = isCategoryRequired;
        });
    }
}
